module.exports = __webpack_public_path__ + "assets/photos/memories/frame-8-mobile--2d1237354924a4f10fe93512e7eb19a8.jpg";